<template>
    <v-card>
    <v-navigation-drawer
    v-model="right_drawer"
    app dark      
    right
    width="400px"
    >
      <template v-slot:prepend>
        <v-list-item >
         
          <v-list-item-icon>
           <v-icon> mdi-eye </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">View Project and create POI</v-list-item-title>
            
          </v-list-item-content>
           <v-btn
          icon
          @click.stop="close_right_sidebar" 
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        </v-list-item>
      

      </template>

      <v-divider></v-divider>

  <template>
  <v-alert v-if="project_visibility=='Publish' && !editable"
  color="indigo"
  dark
  icon="mdi-publish"
  border="left"
  class="mx-2"
  >
  The Project has been published
  </v-alert>

  <v-alert v-else-if="!editable"
  color="indigo"
  dark
  icon="mdi-key"
  border="left"
  class="mx-2"
  >
  The Project is still in Draft Mode
  </v-alert>

  <v-form
    class="mx-2"
    ref="form"
    v-model="valid"
    lazy-validation
  >
     <v-btn
      color="success"
      class=""
      block
      @click="add_poi"
    >
      <v-icon left dark>mdi-plus-circle</v-icon> Add POI in this Project
      </v-btn>

    <v-text-field
      :disabled="!editable"
      v-model="title"
      :counter="100"
      :rules="titleRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Title of the Project
    </template>
    </v-text-field>

     <v-text-field
      @keydown="resetValidation()"
      :disabled="!editable"
      v-model="latitude"
      
      :rules="latitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Latitude (in WGS-84 reference system)
    </template>
    </v-text-field>
     <v-text-field
     @keydown="resetValidation()"
      :disabled="!editable"
      v-model="longitude"
      
      :rules="longitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Longitude (in WGS-84 reference system)
    </template>
    </v-text-field>
	<!--    because we removed range from projects
    <v-text-field
       @keydown="resetValidation()"
      :disabled="!editable"
      v-model="range"
      
      :rules="rangeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Range
    </template>
    </v-text-field>  -->
   <!--
    <v-btn :disabled="!editable" :loading="pick_a_point" block color="blue-grey"  @click="pick_point" >
       <v-icon left>mdi-map-marker</v-icon> Marker
        <template v-slot:loader>
        <span>Waiting to pick a point...</span>
      </template>

    </v-btn> -->

    <v-textarea
          v-model="description"
          :disabled="!editable"
          name="input-7-1"
          label="Project Description"
          value="..."
          hint="Insert something about the project"
        ></v-textarea>

      <v-img max-height="200" contain  class="mb-4"  :src="image_path"  v-if="!editable && image_path">
     
      </v-img>


      <v-row v-if="!editable && multimedia_type==2 && video_path" justify="center" class="mt-0 pt-0 mb-4 mx-2">
          <Media 
		   :style="{  width: '350px'}"
           :kind="'video'"
           :controls="true"
           :src="[video_path]">  
          </Media>
      </v-row>

         
      <v-select
        v-if="editable"
        v-model="media_action"
        :items="media_actions"
        label="Media"
        style="max-width: 500px;" 
        
      ></v-select>

	   <v-select v-if="editable"
        v-model="project_visibility"
        :items="project_visibility_items"
        label="Project Visibility"
        style="max-width: 250px;"
        
      ></v-select>
       <!--
       <v-select
        v-if="file_type=='Video' && editable"
        v-model="video_input_mode"
        :items="video_input_modes"
        label="Video Input Mode"
        style="max-width: 250px;"
        
      ></v-select> -->
      <!--
      <v-text-field
      :disabled="!editable"
      v-if="(file_type=='Video' && video_input_mode=='Link' && editable) || (!editable && multimedia_type==3)"
      v-model="video_link"
      label="Video Link"
      required
    ></v-text-field> -->


      <v-btn v-if="!editable && multimedia_type==1"
      color="success"
      class="mb-3"
      block
      @click="download_image"
    >
      <v-icon left dark>mdi-download</v-icon> Download Project Image
      </v-btn>
       
       <v-btn v-if="!editable && multimedia_type==2"
      color="success"
      class="mb-3"
      block
      @click="download_video"
    >
      <v-icon left dark>mdi-download</v-icon> Download Project Video
      </v-btn>

      <v-file-input v-if="editable && (media_action=='Replace image with another one' || media_action=='Replace video with image' || media_action=='Add image')"  v-model="image_file" :rules="imageRules"  prepend-icon="mdi-camera" chips show-size accept="image/*" label="Project Image"></v-file-input>
      <v-file-input v-if="editable && (media_action=='Add video' || media_action=='Replace image with video' || media_action=='Replace video with another one') "  v-model="video_file" :rules="videoRules"  prepend-icon="mdi-video" chips show-size accept="video/*" label="Project Video"></v-file-input>


   
<v-btn
     
      color="success"
      class="mr-6 white--text"
      @click="undo"
    
    > 
    <v-icon left dark>{{edit_or_undo_icon}}</v-icon> {{edit_or_undo}}
      
      
    </v-btn>

   

    <v-btn
      :disabled="!editable"
      color="error"
      class="mr-6"
      @click="reset"
    >
      <v-icon left dark>mdi-eraser</v-icon> Reset Form
      
    </v-btn>
    <v-btn
      :loading="waiting_for_storage"
      :disabled="!editable || waiting_for_storage"
      color="success"
      class="mt-4"
      block
      @click="store_project"
      
    >
     <v-icon left>mdi-content-save</v-icon> Store Project
      
    </v-btn>
    <v-btn
      :disabled="!editable"
      color="error"
      class="mt-4"
      block
      @click="delete_dialog=true"
      
    >
     <v-icon left>mdi-delete</v-icon> Delete Project
      
    </v-btn>

   
  </v-form>
</template>
   
   

  

  

  

    </v-navigation-drawer>


   <v-snackbar
      v-model="instructions_snackbar"
      :timeout= "instructions_snackbar_timeout"
      :multi-line="instructions_snackbar_multiline"
    >
      Click on map in order to set automatically latitude and longitude. Alternatively you can set manually the coordinates.  
      <v-btn
        color="red"
        text
        @click="instructions_snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>







    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

   <v-snackbar
      v-model="file_snackbar"
      :bottom="file_snackbar_y === 'bottom'"
      :color="file_snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="file_snackbar_y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ file_snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>


<template>
  <v-row justify="center">
    <v-dialog v-model="delete_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Project?</v-card-title>
        <v-card-text>Are you sure you want to delete the Project? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="delete_project">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>




   <v-overlay light :value="overlay" z-index=1000 opacity="0.1">
    <v-progress-circular
      :rotate="-90"
      :size="100"
      :width="15"
      :value="file_upload_percentage"
      color="indigo"
    >
      {{ file_upload_percentage }}
    </v-progress-circular>
    </v-overlay>

  </v-card>








</template>

<script>
  
    import Media from '@dongido/vue-viaudio'
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    import router from '../router';
    export default {

        components: {  Media },
        name: 'ProjectEdit',
        data: function () {
            return {
		project_visibility: 'Publish',
		project_visibility_items: ['Publish','Keep it as draft'],
		
		instructions_snackbar: false,
		instructions_snackbar_multiline: true,
		instructions_snackbar_timeout: 0,


        image_path: null,
        video_path: null,
        overlay: false,
        file_upload_percentage: null,

        file_upload_config : {
        headers: { 'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //alert(percentCompleted);
            this.file_upload_percentage = percentCompleted;
        }

        },      

        relevant_pois: [],
        media_actions: [],
        media_action: null,
        //video_input_modes: ['Link','File'],
        //video_input_mode: 'Link',

        delete_dialog: false,

        editable: false,
        project_uuid: null,


        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


        file_snackbar_color: '',
        file_snackbar: false,
        file_snackbar_text: '',
        file_snackbar_y: 'bottom',


      waiting_for_storage: false,
      image_file: null,
      video_file: null,
      //pick_a_point: false,
     
      right_drawer: true,



      valid: true,
      title: '',
      titleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 10 characters',
      ],
      latitude: null,
      latitudeRules: [
        v => !!v || 'Latitude is required (in WGS-84 reference system)',
        v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Latitude should be a Real Number (in WGS-84 reference system)',
        /*v =>  this.check_if_pois_inside_circle(this.longitude,v,this.range) || 'All Pois should be included within Project Range',  removed range from project*/
      ],
      longitude: null,
      longitudeRules: [
        v => !!v || 'Longitude is required (in WGS-84 reference system)',
        v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Longitude should be a Real Number (in WGS-84 reference system)',
        /*v =>  this.check_if_pois_inside_circle(v,this.latitude,this.range) || 'All Pois should be included within Project Range', removed range from project*/
      ],
	  //range: null,  because we removed range from project
	  /*
      rangeRules: [
        v => !!v || 'Range is required',
        v => /^[1-9]\d+$/.test(v) || 'Range should be a Positive Integer',
        v =>  this.check_if_pois_inside_circle(this.longitude,this.latitude,v) || 'Increase project range to include all pois',
      ], */
      imageRules: [
        v => (!!v  && (this.media_action=='Add image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image')   ) || 'Image is required',   
      ],
       videoRules: [
        v => (!!v  && (this.media_action=='Add video'  || this.media_action=='Replace image with video'  || this.media_action=='Replace video with another one' )   ) || 'Video is required',   
      ],
      
      description: '',
      multimedia_type: null,
      //video_link: null
      
      

                
            };
        },
        computed: {
            edit_or_undo: function () {
            
            return this.editable ? "Undo" : "Edit Project" 


            },
            edit_or_undo_icon: function () {
            
            return this.editable ? "mdi-undo" : "mdi-pencil" 


            }


        },
        methods: {

       do_alert()
       {
        alert("asdasd");

       },   

      check_if_pois_inside_circle(project_longitude, project_latitude, range)
      {
       let check_ok= true;
       //console.log(range);
       this.relevant_pois.forEach(poi => 
       {
       if(this.calcCrow(project_latitude,project_longitude,poi.point.coordinates[1], poi.point.coordinates[0]) * 1000 > range) check_ok=false;
       
       });
      
       return check_ok;
      },

      fetch_relevant_pois(project_uuid)
      {  
        var get_relevant_pois_url=APIS_BASE_URL+"/projects/"+project_uuid+"/pois";
        var get_relevant_pois_url_encoded= encodeURI(get_relevant_pois_url);
   
        axios.get(get_relevant_pois_url_encoded)
                    .then(response => {
                    this.relevant_pois=response.data.relevant_pois;
                    
                            
                    })
                    .catch(error => console.log(error));
      },

       toRad(value)
       {
        return value * Math.PI / 180;

       },

       // distance calculation as the crow flies in kilometers
       calcCrow(lat1, lon1, lat2, lon2)
       {
        var R= 6371; //km
        var dLat= this.toRad(lat2-lat1);
        var dLon= this.toRad(lon2-lon1);
        var lat1_rad= this.toRad(lat1);
        var lat2_rad= this.toRad(lat2);
        var a= Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1_rad) * Math.cos(lat2_rad);
        var c= 2* Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d= R*c;
        return d;
        
       },

        add_poi()
        {
        router.push({ path: '/poi_addition', query: { project_uuid: this.project_uuid }});

        },
        /*
        pick_point()
         {
          this.pick_a_point= !this.pick_a_point;
         
          componentBus.$emit('pick_a_point', this.pick_a_point);

         }, */


        reset () {
         this.$refs.form.reset();
         this.image_file=null;
         this.video_file=null;
         //this.file_type=null;
         this.media_actions=[];
         this.media_action=null;
         componentBus.$emit('destroy_temporary_pin', true);
        },
        undo () {
        if(this.editable)
            this.fetch_project_details();
        this.editable=!this.editable;
        componentBus.$emit('destroy_temporary_pin', true);
      

        },

        resetValidation () {
        this.$refs.form.resetValidation()
        },

        close_right_sidebar () {
        this.right_drawer = false;
        componentBus.$emit('destroy_temporary_pin', true);

      },

       get_image_data(){    //this.three_d_model_obj_path = window.URL.createObjectURL(new Blob([fileData]));
        this.image_path=null;
        let get_image_url=APIS_BASE_URL+"/projects/"+this.project_uuid+"/image/";
        axios({
        url: get_image_url, 
        method: 'GET',
        responseType: 'blob' 
        }).then((response) => {
        this.image_path = window.URL.createObjectURL(new Blob([response.data]));
        console.log(this.image_path.naturalHeight);
});
      
     
      },


      download_image()
      {  
       let download_image_url= APIS_BASE_URL+"/projects/"+this.project_uuid+"/image/";
       axios({
       url: download_image_url, 
       method: 'GET',
       responseType: 'blob' 
       }).then((response) => {
       const url = window.URL.createObjectURL(new Blob([response.data]));
       //window.location.href = url;
       const link = document.createElement('a');
       link.href = url;
       link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
       document.body.appendChild(link);
      link.click();
});
      
        //window.location.href = url;
      
      },
      download_video()
      {
       let download_video_url= APIS_BASE_URL+"/projects/"+this.project_uuid+"/video/";
       axios({
       url: download_video_url, 
       method: 'GET',
       responseType: 'blob' 
       }).then((response) => {
       const url = window.URL.createObjectURL(new Blob([response.data]));
       //window.location.href = url;
       const link = document.createElement('a');
       link.href = url;
       link.setAttribute('download', response.headers['content-disposition'].split("=")[1]); 
       document.body.appendChild(link);
      link.click();
});
      
        //window.location.href = url;
        //console.log("asdasdasddsa");
      },
      fetch_project_details()
      {   
        var get_project_url=APIS_BASE_URL+"/projects/"+this.project_uuid+"/";
        var get_project_url_encoded= encodeURI(get_project_url);
   
        axios.get(get_project_url_encoded)
                    .then(response => {
                    this.title=response.data.title;
                    this.longitude=response.data.point.coordinates[0];
                    this.latitude=response.data.point.coordinates[1];
                    //this.range=response.data.range;    because we removed project range
                    this.description=response.data.description;
                    this.multimedia_type=response.data.multimedia_type;
					this.project_visibility= response.data.published;
					this.project_visibility=   response.data.published === true ?  'Publish'  : 'Keep it as draft';
                    if(this.multimedia_type==0)
                     {
                      this.media_actions.push("Leave project without media");
                      this.media_actions.push("Add image");
                      this.media_actions.push("Add video");
                      this.media_action="Leave project without media";
                     }
                    else if(this.multimedia_type==1)
                    {
                     this.media_actions.push("Keep current image");
                     this.media_actions.push("Delete image");
                     this.media_actions.push("Replace image with another one");
                     this.media_actions.push("Replace image with video");
                     this.media_action="Keep current image";
                     this.get_image_data();
                    }
                    else if(this.multimedia_type==2)
                    {
                     this.media_actions.push("Keep current video");
                     this.media_actions.push("Delete video");
                     this.media_actions.push("Replace video with another one");
                     this.media_actions.push("Replace video with image");
                     this.media_action="Keep current video"; 
                     this.video_path= APIS_BASE_URL+"/projects/"+this.project_uuid+"/video/stream/";
                    }
                    //this.video_link=response.data.video_link;
                    //let payload=[this.project_uuid,this.project_uuid];
                   
                        
                    })
                    .catch(error => console.log(error));
      },

      delete_project_image()
      {
       let url_delete_image_query=APIS_BASE_URL+"/projects/"+this.project_uuid+"/image/";
       let encoded_url_delete_image_query= encodeURI(url_delete_image_query);
       axios.delete(encoded_url_delete_image_query)
        .then(function (response) {
        console.log(response.status);
        })

      },
      delete_project_video()
      {
       let url_delete_video_query=APIS_BASE_URL+"/projects/"+this.project_uuid+"/video/";
       let encoded_url_delete_video_query= encodeURI(url_delete_video_query);
       axios.delete(encoded_url_delete_video_query)
        .then(function (response) {
        console.log(response.status);
        })

      },


      delete_project()
      {
       this.delete_dialog=false;
       componentBus.$emit('deleted_project', this.project_uuid);
       //if(this.multimedia_type==1) this.delete_project_image();
       //else if(this.multimedia_type==2) this.delete_project_video();
       let url_delete_project_query=APIS_BASE_URL+"/projects/"+this.project_uuid+"/";
       let encoded_url_delete_project_query= encodeURI(url_delete_project_query);
       axios.delete(encoded_url_delete_project_query)
        .then((response) => {
        
        console.log(response.status);
        
        })
         this.snackbar_color="success";
         this.snackbar_text="The Project has been successfully deleted!"
         this.snackbar=true;
         this.reset();
         this.close_right_sidebar();


      },

       store_project()
        {
           
          
      
          let valid= this.$refs.form.validate();
          //let video_link= (this.file_type=='Video' && this.video_input_mode=='Link') ? this.video_link : null;
          //let video= (this.file_type=='Video') ? this.video_file : null;
          //let image= (this.file_type=='Image') ? this.image_file : null;
          let multimedia_type= null;
          if(this.media_action=='Add image' || this.media_action=='Keep current image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image')
              multimedia_type=1;
          else if(this.media_action=='Add video' || this.media_action=='Replace image with video' || this.media_action=='Keep current video' || this.media_action=='Replace video with another one')
              multimedia_type=2;
          else if(this.media_action=='Leave project without media' || this.media_action=='Delete image' || this.media_action=='Delete video')
              multimedia_type=0;

          let will_upload_image= this.image_file!=null && (this.media_action=='Add image' || this.media_action=='Replace image with another one' || this.media_action=='Replace video with image');
          let will_upload_video= this.video_file!=null && (this.media_action=='Add video' || this.media_action=='Replace image with video' || this.media_action=='Replace video with another one');   
		  
		  let publish=  this.project_visibility === 'Publish' ?  true  : false;
		  console.log("project visibility "+ this.project_visibility);
		 
          //if(image!=null) multimedia_type=1;
          //else if(video!=null) multimedia_type= 2;
          //else multimedia_type=0;
         
          if( valid)    
          {
           this.waiting_for_storage=true;
           let url_query=APIS_BASE_URL+"/projects/"+this.project_uuid+"/";
           let my_url= encodeURI(url_query);
           var payload = {
                    title: this.title,
                    point: {
                      type: "Point",
                      coordinates: [parseFloat(this.longitude),parseFloat(this.latitude)]
                    },
                   // range: this.range,   because we removed range
                    description: this.description,
                    created_by: "aaabbbccc",
                   
                    //video_link: video_link,
                    multimedia_type: multimedia_type,
					published: publish
                   
                }

           
           axios.put(my_url, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {
                              if(! (will_upload_image || will_upload_video) ) 
                              {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The Project has been successfully updated!"
                               this.snackbar=true;

                               this.reset();
                               this.editable=false;
                               this.fetch_project_details();

                              }
                               payload["project_uuid"]=this.project_uuid;
                               componentBus.$emit('updated_project_payload', payload);
                               componentBus.$emit('destroy_temporary_pin', true);

                               
                               //payload.id=response.data.id;
                               //payload.uuid=response.data.project_uuid;
                               //componentBus.$emit('newly_created_project', payload);

                               //now store the file as well
                               if(will_upload_image) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                //if(this.has_image) this.delete_project_file();

                                //alert("save video");

                                 //console.log("projet uuid: "+payload.uuid);
                                let upload_image_url=APIS_BASE_URL+"/projects/"+this.project_uuid+"/image/";
                                let upload_image_encoded_url= encodeURI(upload_image_url);
                                let formData = new FormData();
                                formData.append('file', this.image_file);

                                axios.post( upload_image_encoded_url,
                                 formData,
                                 //{
                                // headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (image_upload_response) =>{

                                if (image_upload_response.status == "201" )
                                  {
                                    this.overlay=false;
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The Project has been successfully updated!"
                                    this.snackbar=true;

                                    this.reset();
                                    this.editable=false;
                                    this.fetch_project_details();
                                   }
                                else
                                 {
                                  console.log('FAILURE with image upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with Project image storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with image upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with Project image storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(will_upload_video) 
                               {
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                 //console.log("projet uuid: "+payload.uuid);
                                let upload_video_url=APIS_BASE_URL+"/projects/"+this.project_uuid+"/video/";
                                let upload_video_encoded_url= encodeURI(upload_video_url);
                                let formData = new FormData();
                                formData.append('file', this.video_file);

                                axios.post( upload_video_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                  this.file_upload_config
                                ).then( (video_upload_response) =>{

                                if (video_upload_response.status == "201" )
                                 {
                                    this.overlay=false;
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The Project has been successfully updated!"
                                    this.snackbar=true;

                                    this.reset();
                                    this.editable=false;
                                    this.fetch_project_details();
                                   }
                                   //console.log('SUCCESS with video upload!!');
                                   
                                else
                                 {
                                  console.log('FAILURE with video upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with Project video storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with video upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with Project video storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(this.media_action=='Delete image')
                                    this.delete_project_image()
                               else if(this.media_action=='Delete video')
                                    this.delete_project_video();
                               //console.log(response.data);
                            }
                            else {
                                //alert("something went wrong");
                                this.waiting_for_storage=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the Project update..."
                                this.snackbar=true;
                            }
                            //this.reset();
                            //this.fetch_project_details();
                            //this.editable=false;
                    })
                    .catch(error => {
                        console.log(error);
                        //alert("something went wrong"+ error);
                        this.waiting_for_storage=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the Project update..."
                        this.snackbar=true;
                    });


 
          }
          
        

        }

       
       
        },

         
     

        
        mounted() {

        componentBus.$on('project_to_edit_uuid', project_uuid => {
        this.reset();
        
        if(project_uuid!=this.project_uuid)
          router.replace({ path: '/project_edit', query: { uuid: project_uuid }});
      
        //componentBus.$emit('destroy_temporary_pin', true);
        componentBus.$emit('destroy_temporary_pin', true);
        this.relevant_pois=[];
        this.right_drawer = true;
        this.editable=false;
        this.project_uuid= project_uuid;
        this.image_path=this.video_path=null;
        this.fetch_project_details();
        this.fetch_relevant_pois(project_uuid);
        

            });

            componentBus.$on('selected_point_coordinates', (project_point_coordinates) => {
              //if(this.pick_a_point)
                //{
                //alert("Lat, Lon : " + project_point_coordinates.lat + ", " + project_point_coordinates.lng);
                this.latitude=project_point_coordinates.lat;
                this.longitude=project_point_coordinates.lng;
                //this.pick_a_point= !this.pick_a_point;
                //}
            });

          

         
         this.project_uuid= this.$route.query.uuid;
         this.fetch_project_details();
         this.fetch_relevant_pois(this.project_uuid);

         //let payload={};
         //payload['point_uuid']=this.project_uuid;
         //payload['type']='project'
         //componentBus.$emit('focus_on_pin',payload);
         

         

    
           
        },
        destroyed() {
             componentBus.$off('project_to_edit_uuid');
             componentBus.$off('selected_point_coordinates');
			 componentBus.$emit('destroy_temporary_pin', true);
			 componentBus.$emit('stop_picking_point', true);
		},
		
		
      watch: {
        editable: {
        handler: function(value, oldVal) {
        if(value) 
		{
		 this.instructions_snackbar=true;
		 componentBus.$emit('pick_a_point', true);
		}
		else 
		 {
		 this.instructions_snackbar=false;
		 componentBus.$emit('stop_picking_point',true);
		 }
        }
    }
  },


    }
</script>

<style scoped>
   
</style>
